<template>
  <div :style="`width:${sizeValue}px ;height:${sizeValue}px ;`">
    <svg :viewBox="`${viewboxValue}`">
     <path :d="path" />
    </svg>
  </div>
  
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
const types: any = {
  mdi: {
    size: 16,
    viewbox: "0 0 24 24",
  },
  "simple-icons": {
    size: 16,
    viewbox: "0 0 24 24",
  },
  default: {
    size: 0,
    viewbox: "0 0 0 0",
  },
}

const props = defineProps({
  typeIcon: { type: String, default: 'mdi' },
  path: { type: String, required: true },
  size: { type: [String, Number], default: 16 },
  viewbox: String,
  flip: {
    type: String,
    validator: (value: string) =>
      ["horizontal", "vertical", "both", "none"].includes(value),
  },
  rotate: { type: Number, default: 0 },
})
const { typeIcon, path, size, viewbox = null, flip, rotate } = props
const styles = computed(() => {
  return {
    "--sx": ["both", "horizontal"].includes(flip || '') ? "-1" : "1",
    "--sy": ["both", "vertical"].includes(flip || '') ? "-1" : "1",
    "--r": isNaN(rotate) ? rotate : rotate + "deg",
  }
})
const defaults: any =types[typeIcon] || types.default
const sizeValue = size || defaults.size
const viewboxValue =  viewbox || defaults.viewbox
</script>

<style scoped>
svg {
  transform: rotate(var(--r, 0deg)) scale(var(--sx, 1), var(--sy, 1));
}

path {
  fill: currentColor;
}
</style>
